var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlentyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 45,
    viewBox: "0 0 87 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8299 16.8877L80.5905 5.08536L79.8468 9.15537L63.8299 16.8877Z",
    fill: "#5B9AF0",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8299 16.8877L80.5905 5.08536L79.8468 9.15537L63.8299 16.8877Z",
    fill: "url(#paint0_linear_5974_18335)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9842 13.879L78.1788 18.2876L63.83 16.888L78.9842 13.879Z",
    fill: "#5B9AF0",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9842 13.879L78.1788 18.2876L63.83 16.888L78.9842 13.879Z",
    fill: "url(#paint1_linear_5974_18335)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8469 9.15452L78.9841 13.8778L63.8299 16.8868L79.8469 9.15452Z",
    fill: "#5B9AF0",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8469 9.15452L78.9841 13.8778L63.8299 16.8868L79.8469 9.15452Z",
    fill: "url(#paint2_linear_5974_18335)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5721 27.0788L80.5904 5.08484L77.305 7.3983L76.5721 27.0788Z",
    fill: "#FD167C",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5721 27.0788L80.5904 5.08484L77.305 7.3983L76.5721 27.0788Z",
    fill: "url(#paint3_linear_5974_18335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7031 9.93452L70.3331 12.3076L76.5721 27.0789L73.7031 9.93452Z",
    fill: "#FD167C",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7031 9.93452L70.3331 12.3076L76.5721 27.0789L73.7031 9.93452Z",
    fill: "url(#paint4_linear_5974_18335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.305 7.39686L73.7033 9.93307L76.5722 27.0774L77.305 7.39686Z",
    fill: "#FD167C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.305 7.39686L73.7033 9.93307L76.5722 27.0774L77.305 7.39686Z",
    fill: "url(#paint5_linear_5974_18335)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.9634V11.7598H1.54236V30.3382H1.61247L9.92019 20.1376H11.7079L6.23955 26.7978L12.6193 36.9634H10.9017L5.32816 27.9546L1.54236 32.3713V36.9634H0Z",
    fill: "#ffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3284 37.384C16.9496 37.384 16.2602 36.496 16.2602 34.7199V11.7598H17.8026V34.9302C17.8026 35.6547 18.048 36.0169 18.5387 36.0169C18.6088 36.0169 18.6906 36.0169 18.7841 36.0169C18.8776 35.9935 19.0061 35.9702 19.1697 35.9468L19.4501 37.2087C19.2865 37.2555 19.123 37.2905 18.9594 37.3139C18.7958 37.3606 18.5855 37.384 18.3284 37.384Z",
    fill: "#ffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9584 37.384C29.5329 37.384 28.2242 37.0335 27.0324 36.3324C25.8639 35.6313 24.9292 34.6264 24.2281 33.3178C23.527 31.9857 23.1765 30.4083 23.1765 28.5855C23.1765 26.7394 23.527 25.162 24.2281 23.8533C24.9292 22.5212 25.8406 21.5047 26.9623 20.8036C28.084 20.0792 29.2641 19.7169 30.5027 19.7169C32.5125 19.7169 34.0899 20.3947 35.235 21.7501C36.38 23.1055 36.9526 25.0217 36.9526 27.4989C36.9526 27.7092 36.9409 27.9195 36.9175 28.1298C36.9175 28.3402 36.8942 28.5505 36.8474 28.7608H24.7539C24.7773 30.1629 25.046 31.4132 25.5601 32.5115C26.0976 33.6099 26.8338 34.4745 27.7685 35.1055C28.7267 35.7365 29.8367 36.052 31.0986 36.052C32.01 36.052 32.8279 35.9117 33.5524 35.6313C34.3002 35.3509 34.9896 34.9887 35.6205 34.5447L36.2515 35.7365C35.5972 36.1337 34.861 36.5077 34.0431 36.8582C33.2252 37.2087 32.197 37.384 30.9584 37.384ZM24.7539 27.4989H35.4803C35.4803 25.3489 35.0363 23.7364 34.1483 22.6615C33.2603 21.5865 32.0568 21.049 30.5378 21.049C29.5796 21.049 28.6799 21.306 27.8386 21.8202C27.0207 22.3343 26.3313 23.0704 25.7705 24.0286C25.2096 24.9867 24.8708 26.1435 24.7539 27.4989Z",
    fill: "#ffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5235 36.9634V20.1376H42.8556L42.9958 22.7316H43.1009C43.9656 21.8669 44.8536 21.1541 45.765 20.5933C46.6998 20.0091 47.7397 19.7169 48.8848 19.7169C50.6141 19.7169 51.8877 20.2544 52.7056 21.3294C53.5469 22.381 53.9676 23.9935 53.9676 26.1668V36.9634H52.4252V26.3771C52.4252 24.5777 52.1214 23.2574 51.5138 22.4161C50.9296 21.5514 49.9481 21.1191 48.5693 21.1191C47.5644 21.1191 46.653 21.3878 45.8351 21.9253C45.0172 22.4395 44.0941 23.2223 43.0659 24.2739V36.9634H41.5235Z",
    fill: "#ffff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.772 37.384C63.1362 37.384 62.0262 36.9166 61.4419 35.9819C60.8577 35.0237 60.5656 33.7968 60.5656 32.3012V21.4696H57.9366V20.2778L60.6007 20.1376L60.811 15.2651H62.143V20.1376H67.0155V21.4696H62.143V32.4414C62.143 33.5164 62.33 34.3811 62.7039 35.0354C63.0778 35.6897 63.8373 36.0169 64.9824 36.0169C65.3095 36.0169 65.6601 35.9702 66.034 35.8767C66.4313 35.7598 66.7818 35.6313 67.0856 35.4911L67.5062 36.753C67.0155 36.9166 66.513 37.0568 65.9989 37.1737C65.5082 37.3139 65.0992 37.384 64.772 37.384Z",
    fill: "#ffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.434 44.6401C69.8031 44.6401 69.2305 44.5233 68.7164 44.2896L69.0669 42.9225C69.2539 42.9926 69.4642 43.051 69.6979 43.0977C69.955 43.1679 70.2003 43.2029 70.434 43.2029C71.4623 43.2029 72.3269 42.7823 73.028 41.941C73.7524 41.0997 74.325 40.0364 74.7456 38.7511L75.2013 37.2788L68.2958 20.1376H69.9783L74.0446 30.7238C74.3016 31.4249 74.5937 32.1961 74.9209 33.0373C75.2481 33.8786 75.5635 34.6732 75.8673 35.421H76.0076C76.2646 34.6732 76.5217 33.8786 76.7787 33.0373C77.0592 32.1961 77.3162 31.4249 77.5499 30.7238L81.1605 20.1376H82.7379L76.0777 39.0666C75.7739 40.0013 75.3649 40.8894 74.8508 41.7307C74.36 42.5953 73.7524 43.2964 73.028 43.8339C72.3036 44.3714 71.4389 44.6401 70.434 44.6401Z",
    fill: "#ffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5974_18335",
    x1: 69.7346,
    y1: 13.9331,
    x2: 82.9419,
    y2: 6.39428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B9AF0",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5974_18335",
    x1: 64.501,
    y1: 13.1731,
    x2: 75.963,
    y2: 8.42347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265209,
    stopColor: "#5B9AF0",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5974_18335",
    x1: 64.0983,
    y1: 15.1486,
    x2: 84.1411,
    y2: 8.25574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186644,
    stopColor: "#5B9AF0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5974_18335",
    x1: 80.4034,
    y1: 14.4647,
    x2: 82.115,
    y2: 4.64573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD167C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5974_18335",
    x1: 77.1154,
    y1: 28.2255,
    x2: 81.7057,
    y2: 9.99462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD167C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5974_18335",
    x1: 83.7584,
    y1: 22.9022,
    x2: 81.9528,
    y2: 3.1717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.226511,
    stopColor: "#FD167C",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlentyIcon);
export default __webpack_public_path__ + "static/media/klenty-icon.e1e1611f75aa704359c0369e0922dba0.svg";
export { ForwardRef as ReactComponent };